export default __webpack_public_path__ + "static/media/Group1626.d3da4257.png";